module.exports = __webpack_public_path__ + "img/cofre.18bba258.svg";